import React from 'react';

import { strings } from 'APP_ROOT/localization';

import BillingInfo from './BillingInfo';
import InvoicesList from './InvoicesList';

export default class BillingAndPaymentsSection extends React.Component {

    render() {

        return (
            <div className="row">
                <div className="col-12">
                    <h2 id="billing">{strings.formatString(strings.billing_details_title)}</h2>
                    <BillingInfo {...this.props} />
                    <InvoicesList {...this.props} />
                </div>
            </div>
        );
    }
}

